import { render } from "./PolicyGroupList.vue?vue&type=template&id=76de3da7&scoped=true"
import script from "./PolicyGroupList.vue?vue&type=script&lang=js"
export * from "./PolicyGroupList.vue?vue&type=script&lang=js"

import "./PolicyGroupList.vue?vue&type=style&index=0&id=76de3da7&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76de3da7"]])

export default __exports__